'use client';

import { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { ShareIcon } from '@heroicons/react/24/outline';

export default function InviteFriends() {
  const { user } = useAuth();
  const [link, setLink] = useState('');
  const [sharing, setSharing] = useState(false);
  const shareMessage = `🚀 JOIN BIZZBOX
The Social Platform for the Network & Business Community 🌐
📢 Promote your project
🔗 Share with your community
🔍 Search & discover new projects
🚨 Scam Alert — stay informed
🤝 Connect with top networkers & communities
🔥 Top Network Community is Here!
👉 Join BizzBox Now:
${link}
BizzBox — Connect • Discover • Promote • Stay Alert`;
  async function copyLink() {
    try {
      await navigator.clipboard.writeText(link);
      toast.success('Invite link copied');
    } catch {
      toast('Select your invite link and copy it manually.');
    }
  }
  async function copyShareMessage() {
    try {
      await navigator.clipboard.writeText(shareMessage);
      toast.success('Invite message copied');
    } catch {
      toast.error('Could not copy your invite message. Please try again.');
    }
  }
  async function shareLink() {
    if (!link || sharing) return;
    const data = { title: '🚀 JOIN BIZZBOX', text: shareMessage };
    if (!navigator.share || (navigator.canShare && !navigator.canShare(data))) {
      await copyShareMessage();
      return;
    }
    setSharing(true);
    try {
      await navigator.share(data);
    } catch (error) {
      if (!(error instanceof Error && error.name === 'AbortError')) await copyShareMessage();
    } finally {
      setSharing(false);
    }
  }
  useEffect(() => {
    setLink(user ? `${window.location.origin}/signup?ref=${encodeURIComponent(user.id)}` : '');
  }, [user?.id]);
  if (!user) return null;
  return (
    <section className="mb-6 rounded-xl border border-border bg-card p-4 space-y-3">
      <h2 className="font-semibold">Invite friends</h2>
      <p className="text-xs text-muted-foreground">
        Share your link. Anyone who signs up through it will automatically become your friend.
      </p>
      <div className="flex flex-wrap gap-2">
        <input
          aria-label="Your invite link"
          readOnly
          value={link}
          onFocus={(event) => event.target.select()}
          className="min-w-0 flex-1 rounded-lg border border-border bg-input px-3 py-2 text-xs"
        />
        <button
          disabled={!link}
          onClick={copyLink}
          className="rounded-lg border border-border px-3 py-2 text-sm font-semibold disabled:opacity-50"
        >
          Copy invite link
        </button>
        <button
          disabled={!link || sharing}
          onClick={shareLink}
          className="flex items-center gap-2 rounded-lg bg-primary px-3 py-2 text-sm font-semibold text-primary-foreground disabled:opacity-50"
        >
          <ShareIcon className="h-4 w-4" aria-hidden="true" />
          {sharing ? 'Sharing...' : 'Share invite link'}
        </button>
      </div>
    </section>
  );
}
